import React from "react";
import DynamicTable from "../widgets/dynamicTable/DynamicTable.jsx";
import HelperMetiers360 from "../../services/HelpersMetiers360.js";
import AuthorizationChecker from "../../services/AuthorizationChecker";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useStoreState } from "easy-peasy";
import DownloadFileComponent from "../widgets/DownloadFile/DownloadFileComponent.jsx";



const ApksTableComponent = ({apks}) => {
  
    const filteredApks = apks ?? [];

    const apkSlugs = useStoreState(state => state.actionSlugs.actionSlugsDispatcher("apks"));

     const groupLoaderConditions = (loaderConditions) => {
           return loaderConditions
           .reduce((acc,condition)  => {
               if(!acc[condition.loaderMinVersion]){ acc[condition.loaderMinVersion] = [];}
               acc[condition.loaderMinVersion].push(condition.deviceType);
               return acc}, {});
           }
   
       const sortType = [
           {
               value: 'apkVersion', label: 'Version',
               test: HelperMetiers360.isArrayContainsValue(filteredApks, "apkVersion"),
               method: (a, b) => HelperMetiers360.sortHeadsetAppVersions(a.apkVersion, b.apkVersion),
               display: (apk) => apk.apkVersion
           },
           {
               value: 'originalName', label: 'Nom fichier original',
               test: HelperMetiers360.isArrayContainsValue(filteredApks, "originalName"),
               method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.originalName, b.originalName),
               display: (apk) => apk.originalName
           },
           {
               value: 'appFilesize', label: 'Taille',
               test: HelperMetiers360.isArrayContainsValue(filteredApks, "appFilesize"),
               method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.appFilesize, b.appFilesize),
               display: (apk) => HelperMetiers360.formatBytes(apk.appFilesize)
           },
           {
            value: 'description', label: 'Description',
            test: HelperMetiers360.isArrayContainsValue(filteredApks, "description"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.description, b.description),
               display: (apk) => apk.description
           },
           {
               value: 'loaderMinVersion', label: 'Loader min',
               test: HelperMetiers360.isArrayContainsValue(filteredApks, "loaderMinVersion"),
               method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.loaderMinVersion, b.loaderMinVersion),
               display: (apk) => apk.loaderMinVersion
           },
           {
               value: 'loaderConditions', label: 'Type casque : version Loader min',
               test: HelperMetiers360.isArrayContainsValue(filteredApks, "loaderConditions"),
               display: (apk) => {
                   if (!apk.loaderConditions) return '-';
                   const grouped = groupLoaderConditions(apk.loaderConditions);
                   return <>{Object.entries(grouped).map(
                       ([version, devices]) => <span key={version}>{
                           devices.every(device => device === null) || devices.length === 0 ? 
                               "Tout casque"
                               : devices.join(', ')} : {version} <br /></span>)}</>
                   },
               flatDisplay: (apk) => {
                   if (!apk.loaderConditions) return '-';
                   const grouped = groupLoaderConditions(apk.loaderConditions);
                   return Object.entries(grouped).map(
                       ([version, devices]) => {
                           return devices.every(device => device === null) || devices.length === 0 ? 
                               "Tout casque"
                               :devices.join(', ')+" : "+version} ).join(' | ')
                   },
           },
           {
            value: 'isKioskMode', label: 'Mode kiosk',
            test: HelperMetiers360.isArrayContainsValue(filteredApks, "isKioskMode"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.isKioskMode, b.isKioskMode),
               display: (apk) => apk.isKioskMode ? 'Oui' : 'Non'
           },
           {
            value: 'headsetCount', label: 'Nb de casques',
            test: HelperMetiers360.isArrayContainsValue(filteredApks, "headsetCount"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.headsetCount, b.headsetCount),
               display: (apk) => apk.headsetCount ?? 0,
           },
           {
            value: 'publicationDate', label: "Date de publication",
            test: HelperMetiers360.isArrayContainsValue(filteredApks, "publicationDate"),
            method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.publicationDate?.date, b.publicationDate?.date),
               display: (apk) => apk.publicationDate ?
                   HelperMetiers360.getdisplayDateType(apk.publicationDate?.date, 'day')
                : '-'
          },
          {
               value: 'createdDate', label: "Date de création",
               test: HelperMetiers360.isArrayContainsValue(filteredApks, "createdAt"),
               method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.createdAt?.date, b.createdAt?.date),
              display: (apk) => apk.createdAt ?
                  HelperMetiers360.getdisplayDateType(apk.createdAt?.date, 'day')
                   : '-'
           },
           {
               value: 'updatedAt', label: "Date de modification",
               test: HelperMetiers360.isArrayContainsValue(filteredApks, "updatedAt"),
               method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.updatedAt?.date, b.updatedAt?.date),
               display: (apk) => apk.updatedAt ?
                   HelperMetiers360.getdisplayDateType(apk.updatedAt?.date, 'day')
                   : '-'
           },
           {
               value: 'download', label: "Télécharger",
               test: AuthorizationChecker.hasUpdateRights('apks'),
               display: (apk) => <DownloadFileComponent variant="light" path={apk.url} icon={true} />,
               flatDisplay: (apk) => apk.url
           },
           {
               value: 'update', label: "Éditer",
               test: AuthorizationChecker.hasUpdateRights('apks'),
               display: (apk) => <Button variant="secondary" as={Link} to={apkSlugs.update.replace(':uniqueId', apk && apk.uniqueId)}>
                   <i className="fas fa-edit"></i>
               </Button>
           }
       ];




    return (
       
        <DynamicTable
            contentTable={filteredApks }
            contentSort={sortType}
            index="uniqueId"
            valueInitSort="apkVersion"
            filename="apk"
        />
           
    );
};

export default ApksTableComponent;
